module.exports = __webpack_public_path__ + "media/images/facebook-4baa598f326e94bd9a57e3209669ff235202ed7a126d19745d28bc8cf2ddcb05.png";